import { DeliveryPointClosure } from '../types/delivery-point-details.type';

// Les bornes voyagent en chaînes ISO, que l'on pourrait comparer telles quelles. On passe malgré
// tout par l'horodatage : une borne écrite hors de l'admin-v2 pourrait porter un autre décalage
// horaire. `'2026-01-02T00:00:00+01:00'` vaut 23:00Z le 1er, donc précède `'2026-01-01T23:30:00Z'`
// — alors que la comparaison de chaînes les range dans l'ordre inverse.
const toTimestamp = (isoDate: string): number => {
  const timestamp = new Date(isoDate).getTime();

  return Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp;
};

export const sortClosures = (closures: DeliveryPointClosure[]): DeliveryPointClosure[] =>
  [...closures].sort((first, second) => {
    const startGap = toTimestamp(first.from) - toTimestamp(second.from);

    return startGap !== 0 ? startGap : toTimestamp(first.to) - toTimestamp(second.to);
  });
